// extracted by mini-css-extract-plugin
export default {"cell-content":"baseTooltipStyles_cell-content__Pndph","text--ellipsis":"baseTooltipStyles_text--ellipsis__jH-A7"};